module.exports = __webpack_public_path__ + "static/media/gr.7863cc98.svg";